import * as React from "react";

function SvgFutureImaging(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M8.423 0h7.153c.522 0 .942.409.942.917v1.575h5.263c1.23 0 2.219.964 2.219 2.162v12.184c0 .868-.52 1.613-1.273 1.958a6.002 6.002 0 00-4.248-7.612 6.247 6.247 0 00-1.887-4.912A6.582 6.582 0 0012 4.418a6.582 6.582 0 00-4.592 1.854 6.247 6.247 0 00-1.902 4.474c0 1.678.684 3.288 1.902 4.475A6.556 6.556 0 0011 16.999V17c0 .701.12 1.374.341 2H2.22C.989 19 0 18.036 0 16.838V4.654c0-1.198.99-2.162 2.219-2.162h5.263V.917c0-.508.42-.917.941-.917z"
        fill="#fff"
      />
      <path
        d="M17.076 11H17a6.002 6.002 0 00-5.843 4.63 5.13 5.13 0 01-2.75-1.382 4.89 4.89 0 01-1.49-3.502c0-1.313.536-2.573 1.49-3.502A5.15 5.15 0 0112 5.794a5.15 5.15 0 013.594 1.45 4.889 4.889 0 011.482 3.757z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 24a7 7 0 100-14 7 7 0 000 14zm0-1a6 6 0 100-12 6 6 0 000 12z"
        fill="#fff"
      />
      <path
        d="M18 18.66c.316-.475.5-1.046.5-1.66 0-.614-.184-1.185-.5-1.66v-.964c0-.336.406-.5.64-.266l2.625 2.624a.378.378 0 010 .532L18.64 19.89a.376.376 0 01-.64-.266v-.964z"
        fill="#fff"
      />
      <path
        d="M15 14a3 3 0 10-.001 5.999A3 3 0 0015 14zm.69 4.235l-1.066-.775a.146.146 0 01-.06-.118v-2.035c0-.08.066-.146.146-.146h.58c.08 0 .146.066.146.146v1.665l.768.559a.145.145 0 01.031.203l-.341.47a.146.146 0 01-.203.031z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgFutureImaging;
